export const liveAwsConfig = {
  aws_project_region: "eu-central-1",
  aws_cognito_identity_pool_id:
    "eu-central-1:afe386ed-81b9-4bfe-aa0b-5b51c3c123db",
  aws_cognito_region: "eu-central-1",
  aws_user_pools_id: "eu-central-1_wKWynzCwH",
  aws_user_pools_web_client_id: "vugj54s4r74h8lf5gjpbtvn28",
  oauth: {},
  aws_appsync_graphqlEndpoint:
    "https://u3tdajw5w5hg3gg2mzbyv3f46u.appsync-api.eu-central-1.amazonaws.com/graphql",
  aws_appsync_region: "eu-central-1",
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
  aws_user_files_s3_bucket:
    "cleantagger-mobilebf9822faf764404ea47e7c0c278felive-live",
  aws_user_files_s3_bucket_region: "eu-central-1",
};
